import React from "react";

import PageHeading from "../../../../components/common/PageHeading";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import RightBar from "../../../../components/common/RightBar";

import { Col, Collapse, Row } from "antd";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { HiDocumentDuplicate } from "react-icons/hi";
import { TbEdit } from "react-icons/tb";

import {
  applicantTemplates,
  ownerTemplates,
  tenantTemplates,
  vendorTemplates,
} from "../../../../data/communications";

import "./LetterTemplates.css";

const { Panel } = Collapse;

const LettersRightBarData = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "New Tenant Letter",
      "1",
      "",
      "",
      "/communication/letters_templates/templates/new-tenant-letter-template"
    ),
    RightBarMethod(
      "New Owner Letter",
      "2",
      "",
      "",
      "/communication/letters_templates/templates/new-owner-letter-template"
    ),
    RightBarMethod(
      "New Vendor Letter",
      "3",
      "",
      "",
      "/communication/letters_templates/templates/new-vendor-letter-template"
    ),
  ]),
  RightBarMethod("STATEMENTS", "t2", <i className="fa-solid fa-file"></i>, [
    RightBarMethod(
      "Send Owner Packets",
      "4",
      "",
      "",
      "/communication/letters_templates/send_owner_packets"
    ),
    RightBarMethod("Send Statements", "5", "", "", ""),
  ]),
  RightBarMethod("LETTERS", "t3", <i className="fa-solid fa-file-lines"></i>, [
    RightBarMethod("3-Day Notices", "6", "", "", ""),
    RightBarMethod("Tenant Unpaid Charges", "7", "", "", ""),
    RightBarMethod("Owner Portal ", "8", "", "", ""),
    RightBarMethod("Announcement", "9", "", "", ""),
    RightBarMethod("Resident Portal Activation", "10", "", "", ""),
  ]),
];

function LetterTemplates() {
  return (
    <>
      <div className="letter-templates">
        <PageHeading heading="Letter Templates" />
        <p className="para-text">
          Choose a letter template, or create a new one from the Tasks bar.
        </p>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <div className="collapse-container">
              <Collapse
                expandIcon={({ isActive }) =>
                  isActive ? <RiArrowDownSLine /> : <RiArrowUpSLine />
                }
                defaultActiveKey={["1"]}
              >
                <Panel header="Tenant" key="1">
                  <Row className="header-row">
                    <Col span={8} className="header-col">
                      <span>Letter</span>
                    </Col>
                    <Col span={12} className="header-col">
                      <span>Description</span>
                    </Col>
                    <Col span={4} className="header-col">
                      <span>Action</span>
                    </Col>
                  </Row>
                  {/* {tenantTemplates.map((item, index) => {
                    return (
                      <Row key={index} className="data-row">
                        <Col span={8} className="data-col">
                          <span className="onclick-text">{item.letter}</span>
                        </Col>
                        <Col span={12} className="data-col">
                          <span>{item.Description}</span>
                        </Col>
                        <Col span={4} className="data-col">
                          <div className="action">
                            <TbEdit />
                            <span className="onclick-text">Edit</span>
                          </div>
                          <div className="action">
                            <HiDocumentDuplicate />
                            <span className="onclick-text">Duplicate</span>
                          </div>
                        </Col>
                      </Row>
                    );
                  })} */}
                </Panel>
              </Collapse>
            </div>
          </Col>
          <Col span={24}>
            <div className="collapse-container">
              <Collapse
                expandIcon={({ isActive }) =>
                  isActive ? <RiArrowDownSLine /> : <RiArrowUpSLine />
                }
                defaultActiveKey={["1"]}
              >
                <Panel header="Owner" key="1">
                  <Row className="header-row">
                    <Col span={8} className="header-col">
                      <span>Letter</span>
                    </Col>
                    <Col span={12} className="header-col">
                      <span>Description</span>
                    </Col>
                    <Col span={4} className="header-col">
                      <span>Action</span>
                    </Col>
                  </Row>
                  {/* {ownerTemplates.map((item, index) => {
                    return (
                      <Row key={index} className="data-row">
                        <Col span={8} className="data-col">
                          <span className="onclick-text">{item.letter}</span>
                        </Col>
                        <Col span={12} className="data-col">
                          <span>{item.Description}</span>
                        </Col>
                        <Col span={4} className="data-col">
                          <div className="action">
                            <TbEdit />
                            <span className="onclick-text">Edit</span>
                          </div>
                          <div className="action">
                            <HiDocumentDuplicate />
                            <span className="onclick-text">Duplicate</span>
                          </div>
                        </Col>
                      </Row>
                    );
                  })} */}
                </Panel>
              </Collapse>
            </div>
          </Col>
          <Col span={24}>
            <div className="collapse-container">
              <Collapse
                expandIcon={({ isActive }) =>
                  isActive ? <RiArrowDownSLine /> : <RiArrowUpSLine />
                }
                defaultActiveKey={["1"]}
              >
                <Panel header="Vendor" key="1">
                  <Row className="header-row">
                    <Col span={8} className="header-col">
                      <span>Letter</span>
                    </Col>
                    <Col span={12} className="header-col">
                      <span>Description</span>
                    </Col>
                    <Col span={4} className="header-col">
                      <span>Action</span>
                    </Col>
                  </Row>
                  {/* {vendorTemplates.map((item, index) => {
                    return (
                      <Row key={index} className="data-row">
                        <Col span={8} className="data-col">
                          <span className="onclick-text">{item.letter}</span>
                        </Col>
                        <Col span={12} className="data-col">
                          <span>{item.Description}</span>
                        </Col>
                        <Col span={4} className="data-col">
                          <div className="action">
                            <TbEdit />
                            <span className="onclick-text">Edit</span>
                          </div>
                          <div className="action">
                            <HiDocumentDuplicate />
                            <span className="onclick-text">Duplicate</span>
                          </div>
                        </Col>
                      </Row>
                    );
                  })} */}
                </Panel>
              </Collapse>
            </div>
          </Col>
          <Col span={24}>
            <div className="collapse-container">
              <Collapse
                expandIcon={({ isActive }) =>
                  isActive ? <RiArrowDownSLine /> : <RiArrowUpSLine />
                }
                defaultActiveKey={["1"]}
              >
                <Panel header="Applicant" key="1">
                  <Row className="header-row">
                    <Col span={8} className="header-col">
                      <span>Letter</span>
                    </Col>
                    <Col span={12} className="header-col">
                      <span>Description</span>
                    </Col>
                    <Col span={4} className="header-col">
                      <span>Action</span>
                    </Col>
                  </Row>
                  {/* {applicantTemplates.map((item, index) => {
                    return (
                      <Row key={index} className="data-row">
                        <Col span={8} className="data-col">
                          <span className="onclick-text">{item.letter}</span>
                        </Col>
                        <Col span={12} className="data-col">
                          <span>{item.Description}</span>
                        </Col>
                        <Col span={4} className="data-col">
                          <div className="action">
                            <TbEdit />
                            <span className="onclick-text">Edit</span>
                          </div>
                          <div className="action">
                            <HiDocumentDuplicate />
                            <span className="onclick-text">Duplicate</span>
                          </div>
                        </Col>
                      </Row>
                    );
                  })} */}
                </Panel>
              </Collapse>
            </div>
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={LettersRightBarData} />
      </div>
    </>
  );
}

export default LetterTemplates;
